export default "__VITE_ASSET__BlTHDOnL__"